module.exports = __webpack_public_path__ + "img/bus_title_img_6.8bc16d3d.svg";